import ChartContest from "../components/ChartContest";
import CardRanking from "../components/CardRanking";
import PieChartContest from "../components/PieChartContest";
import ContestCard from "../../../features/dashboard/contest/components/ContestCard";
import "./dashboard.css";
import { getContest, getContestByID, getContestMe } from "../../../api/contest";
import React, { useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingIux from "../../../components/loading";

const locale = require("react-redux-i18n").I18n;

const DashboardContest = () => {
  const [dataCard, setDataCard] = React.useState();
  const [dataMe, setDataMe] = useState();
  const [data, setData] = React.useState([]);
  const history = useHistory();
  const { lang } = useParams();
  const account = useSelector((state) => state.user.accounts);

  const filterAccountNumber = useMemo(() => {
    const accountId = data.filter((e) => e?.id === dataCard?.id);

    return account.filter(
      (e) => e.account_type_id === accountId[0]?.account_type_id
    );
  }, [account, data, dataCard]);

  const fetchContests = async () => {
    try {
      const response = await getContest({ status: "opening" });
      const data = response.data.data;
      setData(data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  const contestId = localStorage.getItem("contestId");

  const fetchContestMe = async () => {
    try {
      const data = await getContestMe({ id: contestId });
      setDataMe(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchContestsByID = async () => {
    try {
      const response = await getContestByID({ id: contestId });
      const data = response.data.data || [];
      setDataCard(data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  React.useEffect(() => {
    fetchContestsByID();
    fetchContestMe();
    fetchContests();
  }, []);

  if (!dataCard || !dataMe) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
        <LoadingIux />
      </div>
    );
  }

  return (
    <div className="bg-white p-4" style={{ borderRadius: 20 }}>
      <div className="d-flex align-items-center" style={{ gap: "14px" }}>
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => {
            history.push(`/${lang}/wallet/contest/new-events`);
          }}
          style={{ cursor: "pointer" }}
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.7071 13.7929C20.0976 14.1834 20.0976 14.8166 19.7071 15.2071L15.4142 19.5H27C27.5523 19.5 28 19.9477 28 20.5C28 21.0523 27.5523 21.5 27 21.5H15.4142L19.7071 25.7929C20.0976 26.1834 20.0976 26.8166 19.7071 27.2071C19.3166 27.5976 18.6834 27.5976 18.2929 27.2071L12.2929 21.2071C11.9024 20.8166 11.9024 20.1834 12.2929 19.7929L18.2929 13.7929C18.6834 13.4024 19.3166 13.4024 19.7071 13.7929Z"
            fill="black"
          />
        </svg>
        <p className="text-header-account-wallet text-left w-100">
          {locale.t("dashboardContest.dashboard")}
        </p>
      </div>
      {dataMe?.data.length > 0 && dataMe?.data[0]?.status === "preparing" && (
        <div
          style={{
            width: "100%",
            backgroundColor: "#FEF9E6",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "8px",
            padding: "12px 8px",
            borderRadius: "8px",
            marginTop: "24px",
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.9987 2.66667C5.05318 2.66667 2.66536 5.05448 2.66536 8C2.66536 10.9455 5.05318 13.3333 7.9987 13.3333C10.9442 13.3333 13.332 10.9455 13.332 8C13.332 5.05448 10.9442 2.66667 7.9987 2.66667ZM1.33203 8C1.33203 4.3181 4.3168 1.33333 7.9987 1.33333C11.6806 1.33333 14.6654 4.3181 14.6654 8C14.6654 11.6819 11.6806 14.6667 7.9987 14.6667C4.3168 14.6667 1.33203 11.6819 1.33203 8ZM7.33203 5.33333C7.33203 4.96514 7.63051 4.66667 7.9987 4.66667H8.00536C8.37356 4.66667 8.67203 4.96514 8.67203 5.33333C8.67203 5.70152 8.37356 6 8.00536 6H7.9987C7.63051 6 7.33203 5.70152 7.33203 5.33333ZM7.9987 6.66667C8.36689 6.66667 8.66536 6.96514 8.66536 7.33333V10.6667C8.66536 11.0349 8.36689 11.3333 7.9987 11.3333C7.63051 11.3333 7.33203 11.0349 7.33203 10.6667V7.33333C7.33203 6.96514 7.63051 6.66667 7.9987 6.66667Z"
              fill="#D2B554"
            />
          </svg>
          <div
            style={{ color: "#C29A05", fontSize: "14px", lineHeight: "20px" }}
          >
            {locale.t("dashboardContest.contest_minimum_deposit").replace(
              "${value}",
              dataCard?.minimum_join
            )}
          </div>
        </div>
      )}
      <div className="d-flex flex-column" style={{ gap: "24px" }}>
        {dataCard && dataMe ? (
          <ContestCard
            data={dataCard}
            size="horizontal"
            userStatus={dataMe}
            accountNumber={filterAccountNumber[0]?.account_type_id}
            fetchContestMe={fetchContestMe}
          />
        ) : (
          <LoadingIux />
        )}
        <ChartContest status={dataCard} />
        <div className="flex-container">
          <div className="flex-item">
            <CardRanking status={dataCard} dataMe={dataMe} fetchContestMe={fetchContestMe} />
          </div>
          <div className="flex-item">
            <PieChartContest status={dataCard} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContest;
